<template>
    <section>
        <jetton-wallet v-if="type === 'jetton_wallet' || skeletonHint === 'jetton_wallet'"
            v-bind:address="address"
            v-bind="props"
            v-bind:wallet="wallet"
        />
    </section>
</template>

<script>
import { getAddressInfo, getJettonInfoOldApi } from '~/api';
import { getJettonInfo } from '~/api/toncenterV3';
import { showToast } from '~/toast.js';
import JettonWallet from './JettonWallet.vue';

export default {
    props: {
        address: {
            type: String,
            required: true,
        },
        skeletonHint: {
            type: String,
            default: 'jetton_wallet',
            required: false,
        },
    },

    data() {
        return {
            type: undefined,
            props: undefined,
            activeTab: 'transactions',
            wallet: {},
        };
    },

    watch: {
        $route: 'loadData',
    },

    created() {
        this.loadData();
    },

    methods: {
        reset() {
            this.props = undefined;
            this.type = undefined;
        },

        async loadData() {
            this.reset();
            const result = await getJettonInfoOldApi(this.address);
            this.wallet = await getAddressInfo(this.address);

            switch (result.type) {
                case 'jetton_wallet': {
                    const adminAddress = result?.jetton_wallet?.jetton_address;
                    const jettonToncenter = await getJettonInfo(adminAddress);

                    const jettonAddress = jettonToncenter.jetton_masters[0]?.address;
                    const metadata = jettonToncenter.metadata[jettonAddress]?.token_info[0];

                    const jettonMeta = {
                        symbol: metadata?.symbol,
                        image: metadata?.extra,
                        master_wallet: jettonToncenter.address_book[jettonAddress]?.user_friendly,
                        decimals: Number(metadata?.extra?.decimals) || 9,
                    };

                    this.props = Object.freeze({ ...result.jetton_wallet, jetton: jettonMeta });
                    this.type = 'jetton_wallet';
                    break;
                }

                case 'jetton': {
                    this.$router.replace(this.$localizeRoute({
                        name: 'jetton',
                        params: { address: this.address },
                    }));
                    break;
                }

                default: {
                    showToast(this.$t('jetton.error.redirect_invalid'));

                    this.$router.replace(this.$localizeRoute({
                        name: 'address',
                        params: { address: this.address },
                    }));
                }
            }
        },
    },

    components: {
        JettonWallet,
    },
};
</script>
